import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { INTERACTION_TYPES_FOR } from "../../constants";
import { AssignmentCellProps } from "../../types/assignmentCell";

const AssignmentCell = (props: AssignmentCellProps) => {
  const { entityType, interactionType, profileId, profiles, onSet } = props;

  if (!INTERACTION_TYPES_FOR[entityType].includes(interactionType)) {
    return (
      <td className="px-2 py-1.5 text-center">
        <span className="text-xs text-muted-foreground/40">—</span>
      </td>
    );
  }

  return (
    <td className="px-1 py-1.5 text-center">
      <Select
        value={profileId ?? "__none__"}
        onValueChange={(v) =>
          onSet(entityType, interactionType, v === "__none__" ? null : v)
        }
      >
        <SelectTrigger className="h-7 text-xs w-28 mx-auto bg-background">
          <SelectValue placeholder="None" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__none__">None</SelectItem>
          {profiles.map((p) => (
            <SelectItem key={p.id} value={p.id}>
              {p.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </td>
  );
};

export default AssignmentCell;
